import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './CurrentCreditCard.styles';
import {
  Button, Checkbox, IconSecurity, SelectField, Skeleton,
} from 'gatorcomponents';
import { CreditCardPreview } from '@/components/CreditCard/NewCreditCardPreview';
import { isBRServer } from '@/utils/Validators/validation';

const CurrentCreditCard = ({
  invoice,
  currentCreditCardData,
  isButtonLoading,
  submitCurrentCreditCard,
  loadingCreditCardInstallments,
  selectInstallmentsPlaceholder,
  useOnNextRenovationLabel,
  setInstallment,
  setUseOnNextRenovation,
  dueLabel,
  payInvoiceButtonLabel,
  bottomMessage,
  installmentsOptions,
}) => {
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [useCardOnNextRenovation, setUseCardOnNextRenovation] = useState(false);

  const showRenovationCheckbox = invoice && invoice.showCreditCardCheckbox;

  const handleUseCardOnNextRenovation = () => {
    setUseCardOnNextRenovation(!useCardOnNextRenovation);
    setUseOnNextRenovation && setUseOnNextRenovation(!useCardOnNextRenovation);
  };

  const handleSetSelectedInstallment = useCallback((option) => {
    setSelectedInstallment(option);
    setInstallment && setInstallment(option);
  }, [setInstallment]);

  const setFirstOptionAsDefault = useCallback(() => {
    if (!isBRServer && installmentsOptions.length > 0) {
      handleSetSelectedInstallment(installmentsOptions[0]);
    }
  }, [installmentsOptions, handleSetSelectedInstallment]);

  useEffect(() => {
    setFirstOptionAsDefault();
  }, [setFirstOptionAsDefault]);


  const cardLastFour = currentCreditCardData && currentCreditCardData.cardLastFour && `**** ${(currentCreditCardData.cardLastFour).replace(/\*/g, '')}`;

  return (
    <Styles.Wrapper>
      <Styles.PaymentWrapper>
        {currentCreditCardData && (
          <Styles.CardInfo>
            <Styles.CardImage>
              <CreditCardPreview creditCard={currentCreditCardData} />
            </Styles.CardImage>
            <Styles.CardData>
              <Styles.CardLastFour>{cardLastFour}</Styles.CardLastFour>
              <Styles.CardDueDate>{dueLabel(currentCreditCardData.expDate)}</Styles.CardDueDate>
            </Styles.CardData>
          </Styles.CardInfo>
        )}

        {isBRServer && (
          <Styles.SelectContainer>
            {!loadingCreditCardInstallments && (
            <SelectField
              withScroll
              value={selectedInstallment && selectedInstallment.label}
              options={installmentsOptions}
              placeholder={selectInstallmentsPlaceholder}
              onClickSelect={handleSetSelectedInstallment}
            />
            )}
            {loadingCreditCardInstallments && <Skeleton width="380px" height="60px" />}
          </Styles.SelectContainer>
        )}
      </Styles.PaymentWrapper>
      {showRenovationCheckbox && (
        <Styles.CheckboxContainer onClick={handleUseCardOnNextRenovation}>
          <Checkbox checked={useCardOnNextRenovation} />
          {useOnNextRenovationLabel}
        </Styles.CheckboxContainer>
      )}
      <Button
        label={payInvoiceButtonLabel}
        size="large"
        onClick={submitCurrentCreditCard}
        loading={isButtonLoading}
        disabled={isButtonLoading || !selectedInstallment}
      />
      <Styles.BottomMessage>
        <IconSecurity size="sm" color="primaryExtraDark" />
        <Styles.BottomMessageText>
          {bottomMessage}
        </Styles.BottomMessageText>
      </Styles.BottomMessage>
    </Styles.Wrapper>
  );
};

export default CurrentCreditCard;
